import { useApi } from './useApi';
import { apiService } from '../services/api';

interface ExpectationCard {
  id: number;
  title: string;
  description: string;
}

interface ButtonData {
  id: number;
  text: string;
  url: string;
  variant: 'primary' | 'secondary' | 'tertiary';
  isExternal: boolean;
}

interface ExpectationsSectionData {
  id: number;
  documentId: string;
  title: string;
  description: string;
  expectations: ExpectationCard[];
  button: ButtonData;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export function useExpectationsSection() {
  return useApi<ExpectationsSectionData>(apiService.getExpectationsSection);
} 